import React, { useState } from 'react';
import { DollarSign, Edit, Save, X } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';

const PricingManagement = ({ apiKey }) => {
  const [activeCity, setActiveCity] = useState('lubumbashi');
  const [editingId, setEditingId] = useState(null);
  const [message, setMessage] = useState(null);

  const [pricingData, setPricingData] = useState({
    lubumbashi: {
      mariage: [
        { id: 'lub-mar-1', name: 'Pack Basique', price: 300, features: ['Photos HD', '2h de couverture', '100 photos retouchées'] },
        { id: 'lub-mar-2', name: 'Pack Standard', price: 500, features: ['Photos HD + Vidéo', '4h de couverture', '200 photos + clip 5min'] },
        { id: 'lub-mar-3', name: 'Pack Premium', price: 800, features: ['Photos HD + Vidéo 4K', 'Journée complète', '500 photos + film 15min', 'Album photo'] },
        { id: 'lub-mar-4', name: 'Pack VIP', price: 1200, features: ['Photos HD + Vidéo 4K', '2 jours', 'Photos illimitées', 'Film complet 30min', 'Album luxe', 'Drone', 'Pré-mariage'] }
      ],
      dot: [
        { id: 'lub-dot-1', name: 'Pack Basique', price: 200, features: ['Photos HD', '2h de couverture', '80 photos retouchées'] },
        { id: 'lub-dot-2', name: 'Pack Standard', price: 350, features: ['Photos HD + Vidéo', '3h de couverture', '150 photos + clip 5min'] },
        { id: 'lub-dot-3', name: 'Pack Premium', price: 600, features: ['Photos HD + Vidéo 4K', 'Journée complète', '300 photos + film 10min'] }
      ]
    },
    kolwezi: {
      mariage: [
        { id: 'kol-mar-1', name: 'Pack Basique', price: 350, features: ['Photos HD', '2h de couverture', '100 photos retouchées'] },
        { id: 'kol-mar-2', name: 'Pack Standard', price: 550, features: ['Photos HD + Vidéo', '4h de couverture', '200 photos + clip 5min'] },
        { id: 'kol-mar-3', name: 'Pack Premium', price: 900, features: ['Photos HD + Vidéo 4K', 'Journée complète', '500 photos + film 15min', 'Album photo'] },
        { id: 'kol-mar-4', name: 'Pack VIP', price: 1400, features: ['Photos HD + Vidéo 4K', '2 jours', 'Photos illimitées', 'Film complet 30min', 'Album luxe', 'Drone', 'Pré-mariage'] }
      ],
      dot: [
        { id: 'kol-dot-1', name: 'Pack Basique', price: 250, features: ['Photos HD', '2h de couverture', '80 photos retouchées'] },
        { id: 'kol-dot-2', name: 'Pack Standard', price: 400, features: ['Photos HD + Vidéo', '3h de couverture', '150 photos + clip 5min'] },
        { id: 'kol-dot-3', name: 'Pack Premium', price: 700, features: ['Photos HD + Vidéo 4K', 'Journée complète', '300 photos + film 10min'] }
      ]
    }
  });

  const [tempEdit, setTempEdit] = useState(null);

  const handleEdit = (pack) => {
    setEditingId(pack.id);
    setTempEdit({ ...pack });
  };

  const handleSave = (city, eventType) => {
    setPricingData(prev => ({
      ...prev,
      [city]: {
        ...prev[city],
        [eventType]: prev[city][eventType].map(p => 
          p.id === tempEdit.id ? tempEdit : p
        )
      }
    }));
    setEditingId(null);
    setTempEdit(null);
    setMessage({ type: 'success', text: 'Tarif mis à jour avec succès !' });
    setTimeout(() => setMessage(null), 3000);
  };

  const handleCancel = () => {
    setEditingId(null);
    setTempEdit(null);
  };

  const updateFeature = (index, value) => {
    const newFeatures = [...tempEdit.features];
    newFeatures[index] = value;
    setTempEdit({ ...tempEdit, features: newFeatures });
  };

  const addFeature = () => {
    setTempEdit({ ...tempEdit, features: [...tempEdit.features, ''] });
  };

  const removeFeature = (index) => {
    const newFeatures = tempEdit.features.filter((_, i) => i !== index);
    setTempEdit({ ...tempEdit, features: newFeatures });
  };

  const renderPack = (pack, city, eventType) => {
    const isEditing = editingId === pack.id;
    const currentPack = isEditing ? tempEdit : pack;

    return (
      <Card key={pack.id} className="hover:shadow-lg transition-shadow">
        <CardContent className="p-6">
          {isEditing ? (
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Nom du Pack</label>
                <input
                  type="text"
                  value={currentPack.name}
                  onChange={(e) => setTempEdit({ ...tempEdit, name: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Prix (USD)</label>
                <input
                  type="number"
                  value={currentPack.price}
                  onChange={(e) => setTempEdit({ ...tempEdit, price: parseInt(e.target.value) })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Fonctionnalités</label>
                {currentPack.features.map((feature, idx) => (
                  <div key={idx} className="flex gap-2 mb-2">
                    <input
                      type="text"
                      value={feature}
                      onChange={(e) => updateFeature(idx, e.target.value)}
                      className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500"
                    />
                    <Button
                      onClick={() => removeFeature(idx)}
                      className="bg-red-500 hover:bg-red-600 text-white"
                    >
                      <X className="h-4 w-4" />
                    </Button>
                  </div>
                ))}
                <Button
                  onClick={addFeature}
                  className="w-full bg-gray-200 hover:bg-gray-300 text-gray-700 mt-2"
                >
                  + Ajouter une fonctionnalité
                </Button>
              </div>

              <div className="flex gap-2">
                <Button
                  onClick={() => handleSave(city, eventType)}
                  className="flex-1 bg-green-500 hover:bg-green-600 text-white"
                >
                  <Save className="h-4 w-4 mr-2" />
                  Enregistrer
                </Button>
                <Button
                  onClick={handleCancel}
                  className="flex-1 bg-gray-500 hover:bg-gray-600 text-white"
                >
                  Annuler
                </Button>
              </div>
            </div>
          ) : (
            <>
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="text-xl font-bold text-gray-900">{currentPack.name}</h3>
                  <p className="text-3xl font-bold text-amber-600 mt-2">${currentPack.price}</p>
                </div>
                <Button
                  onClick={() => handleEdit(pack)}
                  className="bg-blue-500 hover:bg-blue-600 text-white"
                >
                  <Edit className="h-4 w-4" />
                </Button>
              </div>

              <ul className="space-y-2">
                {currentPack.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-2 text-gray-700">
                    <span className="text-amber-600 mt-1">✓</span>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </>
          )}
        </CardContent>
      </Card>
    );
  };

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900">Gestion des Tarifs</h2>
        <p className="text-gray-600 mt-1">Modifiez les prix et les fonctionnalités de vos packs</p>
      </div>

      {message && (
        <div className={`mb-6 p-4 rounded-lg ${
          message.type === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
        }`}>
          {message.text}
        </div>
      )}

      {/* City Selector */}
      <div className="mb-6 flex gap-4">
        <Button
          onClick={() => setActiveCity('lubumbashi')}
          className={activeCity === 'lubumbashi' ? 'bg-amber-600 text-white' : 'bg-gray-200 text-gray-700'}
        >
          📍 Lubumbashi
        </Button>
        <Button
          onClick={() => setActiveCity('kolwezi')}
          className={activeCity === 'kolwezi' ? 'bg-amber-600 text-white' : 'bg-gray-200 text-gray-700'}
        >
          📍 Kolwezi
        </Button>
      </div>

      {/* Mariage Packs */}
      <div className="mb-8">
        <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
          <DollarSign className="h-6 w-6 text-amber-600" />
          Packs Mariage - {activeCity === 'lubumbashi' ? 'Lubumbashi' : 'Kolwezi'}
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {pricingData[activeCity].mariage.map(pack => renderPack(pack, activeCity, 'mariage'))}
        </div>
      </div>

      {/* Dot Packs */}
      <div>
        <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
          <DollarSign className="h-6 w-6 text-amber-600" />
          Packs Dot - {activeCity === 'lubumbashi' ? 'Lubumbashi' : 'Kolwezi'}
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {pricingData[activeCity].dot.map(pack => renderPack(pack, activeCity, 'dot'))}
        </div>
      </div>

      {/* Info Box */}
      <Card className="mt-6 bg-blue-50 border-blue-200">
        <CardContent className="p-6">
          <h3 className="font-bold text-blue-900 mb-2">💡 Note</h3>
          <p className="text-sm text-blue-800">
            Les modifications sont enregistrées localement pour le moment. Pour synchroniser avec le site en production, 
            un déploiement sera nécessaire. Une future mise à jour permettra la sauvegarde en base de données.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default PricingManagement;
